import React from 'react';
import { Box, Container, Heading, Text, type BoxProps } from '@chakra-ui/react';
import { motion } from 'framer-motion';
interface SectionProps extends BoxProps {
  children: React.ReactNode;
}
export function Section({
  children,
  ...rest
}: SectionProps) {
  return <Box as="section" py={{
    base: 16,
    md: 24
  }} {...rest} data-id="element-143" data-mp="3fyq95n65mijo">
      <Container maxW="1200px" px={{
      base: 6,
      md: 8
    }} data-id="element-144" data-mp="3kw9oyrii33dq">
        {children}
      </Container>
    </Box>;
}
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'dark' | 'light';
}
export function Eyebrow({
  children,
  tone = 'dark'
}: EyebrowProps) {
  return <Text as="span" display="block" fontSize="xs" fontWeight={600} letterSpacing="0.16em" textTransform="uppercase" color={tone === 'dark' ? 'accent.600' : 'accent.200'} mb={4} data-id="element-145" data-mp="2qn6829x2p53">
      {children}
    </Text>;
}
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  intro?: string;
  tone?: 'dark' | 'light';
  align?: 'left' | 'center';
  maxW?: string;
}
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = 'dark',
  align = 'left',
  maxW = '720px'
}: SectionHeadingProps) {
  return <Box maxW={maxW} mx={align === 'center' ? 'auto' : undefined} textAlign={align} mb={{
    base: 10,
    md: 14
  }} data-id="element-146" data-mp="38cvqs5apr41r">
      {eyebrow ? <Eyebrow tone={tone} data-id="element-147" data-mp="33ldrdloc9biw">{eyebrow}</Eyebrow> : null}
      <Heading as="h2" fontSize={{
      base: '2xl',
      md: '4xl'
    }} color={tone === 'dark' ? 'navy.800' : 'white'} lineHeight={1.2} data-id="element-148" data-mp="3iatemronuytu">
        {title}
      </Heading>
      {intro ? <Text mt={5} fontSize={{
      base: 'md',
      md: 'lg'
    }} color={tone === 'dark' ? 'navy.500' : 'navy.100'} fontWeight={300} data-id="element-149" data-mp="3rc1bd5bj3rlt">
          {intro}
        </Text> : null}
    </Box>;
}
const MotionBox = motion(Box);
interface RevealProps extends BoxProps {
  children: React.ReactNode;
  delay?: number;
}
export function Reveal({
  children,
  delay = 0,
  ...rest
}: RevealProps) {
  return <MotionBox initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.2
  }} transition={{
    duration: 0.5,
    delay,
    ease: 'easeOut'
  }} {...rest} data-id="element-150" data-mp="3s2pzaio8nk0l">
      {children}
    </MotionBox>;
}